import React from 'react';
import { Clock, Calendar, Heart } from 'lucide-react';

const getStatus = () => {
  const now = new Date();
  const day = now.getDay();
  const hour = now.getHours();
  const isWeekday = day >= 1 && day <= 5;
  const openHour = isWeekday ? 10 : 9;
  const closeHour = isWeekday ? 22 : 23;
  const isOpen = hour >= openHour && hour < closeHour;
  if (isOpen) {
    const hoursLeft = closeHour - hour;
    return { status: 'open', text: `Open Now — Closes in ${hoursLeft} hour${hoursLeft > 1 ? 's' : ''}` };
  }
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const nextDay = days[day];
  const nextOpen = isWeekday ? '10:00 AM' : '9:00 AM';
  return { status: 'closed', text: `Closed — Opens ${nextDay} at ${nextOpen}` };
};

const hours = [
  { day: 'Monday – Friday', time: '10:00 AM – 10:00 PM', note: 'Regular Hours', icon: <Clock size={20} />, days: [1,2,3,4,5] },
  { day: 'Saturday', time: '9:00 AM – 11:00 PM', note: 'Weekend Special', icon: <Calendar size={20} />, days: [6] },
  { day: 'Sunday', time: '9:00 AM – 11:00 PM', note: 'Family Day', icon: <Heart size={20} />, days: [0] },
];

const OpeningHours = () => {
  const { status, text } = getStatus();
  const today = new Date().getDay();

  return (
    <section className="section-padding" style={{ backgroundColor: '#F8F8F8' }}>
      <div className="container">
        <div className="text-center mb-5 reveal">
          <span className="section-subtitle">Visit Us</span>
          <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', fontWeight: 600 }}>
            Opening Hours
          </h2>
          <div className="gold-divider-center"></div>
          {/* Live status badge */}
          <div className={`status-badge ${status} mt-3 d-inline-flex`}>
            <span className="status-dot"></span>
            {text}
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8 reveal">
            <div className="p-5" style={{
              backgroundColor: '#ffffff', borderRadius: '16px',
              boxShadow: '0 4px 30px rgba(0,0,0,0.06)'
            }}>
              {hours.map((item, index) => {
                const isToday = item.days.includes(today);
                return (
                  <div key={index}
                    className={`d-flex align-items-center justify-content-between py-4 ${index < 2 ? 'border-bottom' : ''}`}
                    style={{
                      borderColor: '#f0f0f0',
                      backgroundColor: isToday ? 'rgba(212,175,55,0.05)' : 'transparent',
                      borderRadius: isToday ? '8px' : 0,
                      padding: '16px 12px',
                      transition: 'var(--transition)'
                    }}>
                    <div className="d-flex align-items-center gap-3">
                      <div style={{
                        width: '48px', height: '48px', borderRadius: '12px',
                        backgroundColor: isToday ? 'rgba(212,175,55,0.15)' : 'rgba(212,175,55,0.1)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#D4AF37'
                      }}>
                        {item.icon}
                      </div>
                      <div>
                        <h5 className="mb-0" style={{
                          fontFamily: 'Playfair Display, serif', fontWeight: 600, fontSize: '1.1rem',
                          color: isToday ? '#D4AF37' : 'inherit'
                        }}>
                          {item.day}
                          {isToday && <span style={{ fontSize: '0.7rem', marginLeft: '8px', color: '#D4AF37' }}>TODAY</span>}
                        </h5>
                        <span style={{ fontSize: '0.8rem', color: '#999' }}>{item.note}</span>
                      </div>
                    </div>
                    <span style={{ fontSize: '1.1rem', fontWeight: 600, color: '#4CAF50' }}>{item.time}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;
